const policy = [
    {
        name: 'Miễn phí giao hàng',
        description: 'Miễn phí ship với đơn hàng > 239K',
        icon: 'bx bx-shopping-bag',
    },
    {
        name: 'Thanh toán COD',
        description: 'Thanh toán khi nhận hàng (COD)',
        icon: 'bx bx-credit-card',
    },
    {
        name: 'Khách hàng VIP',
        description: 'Ưu đãi dành cho khách hàng VIP',
        icon: 'bx bx-diamond',
    },
    {
        name: 'Hỗ trợ bảo hành',
        description: 'Đổi, sửa đồ tại tất cả store',
        icon: 'bx bx-donate-heart',
    },
];

export default policy;
